import React, {useState} from "react";
import AlertContext from "../hooks/useAlter";
import {Alert, Snackbar} from "@mui/material";

const AlertProvider = ({children}) => {
    const [snack, setSnack] = useState({
        open: false,
        type: "info",
        message: ""
    });

    const show = ({type = "info", message = ""}) => {
        setSnack({
            open: true,
            type,
            message
        });
    };

    const close = () => {
        setSnack((p) => ({...p, open: false}));
    };

    return (
        <AlertContext.Provider value={{show}}>
            {children}
            <Snackbar
                open={snack.open}
                autoHideDuration={3000}
                onClose={close}
                anchorOrigin={{vertical: "bottom", horizontal: "right"}}
            >
                <Alert severity={snack.type} variant="filled" onClose={close}>
                    {snack.message}
                </Alert>
            </Snackbar>
        </AlertContext.Provider>
    );
};

export default AlertProvider;
